// extracted by mini-css-extract-plugin
export var accordion = "index-module--accordion--bc0cf";
export var accordionTitle = "index-module--accordionTitle--9b333";